import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  container: {
    background: '#F7FAFD',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
  },
}));
